<ng-container *phxVar="user$ | async as user">
    @if (user != null) {
        <div class="container">
            <p>
                Eingeloggt als <b>{{ user.uid }}</b>
            </p>
            <button class="btn btn-primary" (click)="logout()">Logout</button>
        </div>
    }

    @if (user == null) {
        <div class="login-form container bg-light border rounded p-3">
            <form (ngSubmit)="login()">
                <div class="mb-3">
                    <label for="inputUsername" class="form-label">Username</label>
                    <input type="text" class="form-control" id="inputUsername" [formControl]="usernameControl" />
                </div>
                <div class="mb-3">
                    <label for="inputPassword" class="form-label">Password</label>
                    <input type="text" class="form-control" id="inputPassword" [formControl]="passwordControl" />
                </div>
                <div class="mb-3">
                    <label for="inputImpersonateAs" class="form-label"
                        >Impersonate As (leave blank for "normal" merchant logins)</label
                    >
                    <input
                        type="text"
                        class="form-control"
                        id="inputImpersonateAs"
                        [formControl]="impersonateAsControl"
                    />
                </div>
                <button type="submit" class="btn btn-primary">Login</button>
            </form>
        </div>
    }
</ng-container>
